export const allTillnumbers = ` {
    tillNumbersNew {
        id
        tillNumber
        name
        insightTypeId
        insightType
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}
`;

export const allPayBills = `
 {
    paybills {
        id
        paybill
        name
        insightTypeId
      
    }
}
`;

export const newAllPaybills = `{
    payBillNew {
        id
        paybill
        name
        insightTypeId
        insightType
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}`;

export const allTransactionType = ` {
    transactionType {
        id
        description
      
    }
}

`;
export const allInsightType = ` {
    insightTypes {
        id
        description
    
    }
}
`;
export const allInsightKeyWords = ` {
    insightKeywords {
        id
        keyWord
        insightTypeId
     
    }
}`;

export const newAllInsightKeyWords = `
{
    insightKeywordNew {
        id
        keyword
        insightTypeId
        insightType
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}`;

export const allTransactionKeywords = ` {
    transactionKeywords {
        id
        keyWord
        regexpression
        transactionTypeId
     
    }
}`;

export const allFSTitles = `
{
    allTitles {
        id
        title
        
    }
}

`;

export const allStatements = `
{
    allStatements {
        id
        userId
        speedPlanId
        customerName
        customerMobile
        emailAddress
        statementPeriod
        requestDate
        summary
        createdDate
        totalWork
        workDone
    }
}
`;

export const allBankStatements = `
{
    bankStatements {
        id
        userId
        typeId
        speedPlanId
        bankId
        dynamicIdentifier
        summary
        createdDate
        createdBy
        updatedDate
        updatedBy
    }
}
`;
export const generateColumnsFromQuery = (query) => {
  // Fields to ignore
  const ignoreFields = ["createdDate", "createdBy", "updatedDate", "updatedBy"];

  // Extract fields from within the object (ignore root)
  const fieldRegex = /(\w+)\n/g;
  const fields = [...query.matchAll(fieldRegex)];

  // Map the extracted field names to the desired column format, ignoring specific fields
  const columns = fields
    .map((field) => field[1])
    .filter((field) => !ignoreFields.includes(field)) // Exclude ignored fields
    .map((field) => ({
      field,
      headerName: formatHeaderName(field),
      flex: 1,
    }));

  return columns;
};

// Utility function to format header names
const formatHeaderName = (field) => {
  return field
    .replace(/([A-Z])/g, " $1") // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
};
